import { render } from "./CulDeSac.vue?vue&type=template&id=de2e8fe6"
import script from "./CulDeSac.vue?vue&type=script&lang=js"
export * from "./CulDeSac.vue?vue&type=script&lang=js"
script.render = render

export default script